var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns1,"data":_vm.data1}}),_c('br'),_c('Page',{attrs:{"total":_vm.total,"show-total":""},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePagesize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }